import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

import SelectItem from './SelectItem';
import SelectItemWrapper from './SelectItemWrapper';
import useCheckPC from '../../hooks/useCheckPC';

const SelectObj = ({ defaultValue, options, selectedValue, onOptionChange, classes, error, props }) => {
	const { isPC } = useCheckPC();
	const labelRef = useRef(null);
	const [isSelectOpen, setIsSelectOpen] = useState(false);

	/** Select 영역 밖 클릭시 닫힘 */
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (labelRef.current && !labelRef.current.contains(event.target)) {
				setIsSelectOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isSelectOpen]);

	const handleOpenSelect = (e) => {
		e.preventDefault();
		setIsSelectOpen(true);
	};

	// 선택된 옵션 찾기
	const selectedOption = options.find((option) => option.value === selectedValue);

	return (
		<div
			className={classNames(
				error && 'error',
				classes,
				'input'
			)}
		>
			<label
				ref={labelRef}
				onMouseDown={handleOpenSelect}
				className={classNames('select-set', {
					'default-value-selected': !selectedValue,
				})}
			>
				<select
					{...props}
					className={classNames(classes && classes)}
					value={selectedValue || ''}
					onChange={(e) => {
						e.preventDefault();
						const option = options.find((opt) => opt.value === e.target.value);
						if (option) {
							onOptionChange({
								label: option.label,
								value: option.value,
								data: option.data,
							});
						}
					}}
				>
					{defaultValue && (
						<option className='default-value' key={0} value={defaultValue}>
							{defaultValue}
						</option>
					)}
					{options.map((option, index) => (
						<option key={index + 1} value={option.value}>
							{option.label}
						</option>
					))}
				</select>
				{isSelectOpen && (
					<SelectItemWrapper>
						{options.map((option) => (
							<SelectItem
								key={option.value}
								onClick={() => {
									setIsSelectOpen(false);
									onOptionChange({
										label: option.label,
										value: option.value,
										data: option.data,
									});
								}}
								isSelected={option.value === selectedValue}
							>
								{option.label}
							</SelectItem>
						))}
					</SelectItemWrapper>
				)}
			</label>
			{error?.message && <span className={classNames('error')}>{error?.message}</span>}
		</div>
	);
};

export default SelectObj;

